import React from "react"

import styles from "./clients.module.css"

import Sumup from "assets/logos/sumup.svg"
import DogHero from "assets/logos/dog-hero.svg"
import QuintoAndar from "assets/logos/quinto-andar.svg"
import Docket from "assets/logos/docket.svg"

const Clients = () => {
  return (
    <section className={styles.clients}>
      <div className="wrapper">
        <p>Melhorando a vida financeira dos colaboradores das empresas</p>
        <ul className={styles.brands}>
          <li>
            <Sumup />
          </li>
          <li>
            <DogHero />
          </li>
          <li>
            <QuintoAndar />
          </li>
          <li>
            <Docket />
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Clients
